declare global {
  interface Window {
    CookiebotCallback_OnLoad?: () => void;
    CookiebotCallback_OnAccept?: () => void;
    CookiebotCallback_OnDecline?: () => void;
  }
}

export default defineNuxtPlugin({
  name: 'cookiebot-consent',
  setup: () => {
    const { user } = useUserStore();
    const { sendConsentWithRetry, isCookiebotAvailable } = useCookiebotConsent();

    let isProcessing = false;

    const sendConsentIfAuthenticated = async () => {
      if (isProcessing || !user.value || !isCookiebotAvailable()) {
        return;
      }

      isProcessing = true;

      try {
        await sendConsentWithRetry(3, 'cookiebot');
      } finally {
        isProcessing = false;
      }
    };

    const originalOnLoad = window.CookiebotCallback_OnLoad;
    const originalOnAccept = window.CookiebotCallback_OnAccept;
    const originalOnDecline = window.CookiebotCallback_OnDecline;

    window.CookiebotCallback_OnLoad = function () {
      if (originalOnLoad) {
        originalOnLoad();
      }
      sendConsentIfAuthenticated();
    };

    window.CookiebotCallback_OnAccept = function () {
      if (originalOnAccept) {
        originalOnAccept();
      }
      sendConsentIfAuthenticated();
    };

    window.CookiebotCallback_OnDecline = function () {
      if (originalOnDecline) {
        originalOnDecline();
      }
      sendConsentIfAuthenticated();
    };

    if (isCookiebotAvailable()) {
      sendConsentIfAuthenticated();
    }

    watch(user, (newUser, oldUser) => {
      if (newUser && !oldUser && isCookiebotAvailable()) {
        sendConsentIfAuthenticated();
      }
    });
  },
});
